import { DetectedDefinition } from '../schemas/DetectedDefinition';

export const getDefinitionDisplayName = (
    def: DetectedDefinition | undefined,
    language: string
): string => {
    if (!def) return '';

    if (def.displayNames && def.displayNames.length > 1) {
        const displayNameObj = def.displayNames.find((name) => name.language === language);
        return displayNameObj ? displayNameObj.display : def.displayName;
    } else {
        return def.displayName;
    }
};
